import { Injectable } from '@angular/core';
import * as smoothscroll from 'smoothscroll-polyfill';
import { AbstractComponentWithScrollContainer } from '../components/abstract-component-with-scroll-container';
import { BasicService } from './basic.service';

smoothscroll.polyfill();

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  constructor(private basicService: BasicService) {}

  scrollIonContentToElement(page: AbstractComponentWithScrollContainer, elementId, distanceFromTopOfContainer = 0) {
    // the scroll container detection algorithm of smoothscroll-polyfill's scrollIntoView()
    // doesn't work with a scroll container within some shadow DOM;
    // that's why the caller must pass the IonContent's scroll container,
    // and why we use offsetTop of the given element to compute where to scroll to.
    const element = this.basicService.document.getElementById(elementId);
    if (element) {
      const scrollContainer = page.scrollContainer;

      const top =
        element.offsetTop -
        distanceFromTopOfContainer -
        this.correctionForShadowDOMLeakingBrowsers(element, scrollContainer);

      setTimeout(() => {
        // when calling localhost endpoints, the ion-infinite-scroll can
        // get ready too late and scroll all the way to the bottom; hence this setTimeout
        scrollContainer?.scrollTo({
          top,
          behavior: 'smooth',
        });
      });
    }
  }

  scrollDurationMs() {
    return 468; // dunno why smoothscroll-polyfill uses this value, perhaps they found it in Chromium sources
  }

  scrollToBottom(page: AbstractComponentWithScrollContainer) {
    if (page?.scrollContainer) {
      page.scrollContainer.scrollTo({
        top: page.scrollContainer.scrollHeight,
        behavior: 'smooth',
      });
    }
  }

  scrollToTop(page: AbstractComponentWithScrollContainer) {
    page.scrollContainer?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  adjustScrollForPage(page: AbstractComponentWithScrollContainer, delta: number) {
    page.scrollContainer.scrollTop += delta;
  }

  private correctionForShadowDOMLeakingBrowsers(element, scrollContainer) {
    // Chrome and Safari don't use the same offset parent:
    // Chrome uses .inner-scroll as the offsetParent (which is a shadow node leak),
    // while Safari and Firefox jump to ion-content.
    // see https://bugs.webkit.org/show_bug.cgi?id=204195 , https://bugzilla.mozilla.org/show_bug.cgi?id=1514074
    // We mustn't substract .inner-scroll's padding for Safari/Firefox
    if (element.offsetParent === scrollContainer) {
      try {
        const containerPaddingTop = this.basicService.window.getComputedStyle(scrollContainer).paddingTop;
        return Number(containerPaddingTop.substring(0, containerPaddingTop.length - 2)); // strip 'px' and convert to number
      } catch {
        return 0;
      }
    }
    return 0;
  }
}
